var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"auto"}},[_c('div',{staticClass:"chart-container",style:([
      {
        position: 'relative',
        height: '400px',
        // width: `${Math.max(data.datasets[0].data.length * this.options.barDistance, 400)}px`,
      },
    ])},[_c('canvas',{ref:"chart",staticStyle:{"max-width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }